import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI, logout } from '../lib/adminAPI';
import { Users, Mail, TrendingUp, Clock, MessageSquare } from 'lucide-react';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const data = await adminAPI.getDashboardStats();
      setStats(data);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="admin-loading">Loading dashboard...</div>;
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div>
          <h1 className="admin-page-title">Dashboard</h1>
          <p className="admin-page-subtitle">Overview of your submissions</p>
        </div>
        <button onClick={logout} className="admin-logout-btn">
          Logout
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon stat-icon-primary">
            <Mail size={24} />
          </div>
          <div className="stat-content">
            <p className="stat-label">Total Contact Submissions</p>
            <p className="stat-value">{stats?.totalContacts || 0}</p>
            {stats?.contactsByStatus && (
              <p className="stat-breakdown" data-testid="dashboard-status-breakdown">
                <span className="lead-status-chip lead-status-new">{stats.contactsByStatus.new} new</span>
                <span className="lead-status-chip lead-status-contacted">{stats.contactsByStatus.contacted} contacted</span>
                <span className="lead-status-chip lead-status-closed">{stats.contactsByStatus.closed} closed</span>
              </p>
            )}
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon stat-icon-success">
            <Users size={24} />
          </div>
          <div className="stat-content">
            <p className="stat-label">Total Agent Applications</p>
            <p className="stat-value">{stats?.totalAgents || 0}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon stat-icon-info">
            <Clock size={24} />
          </div>
          <div className="stat-content">
            <p className="stat-label">Recent Contacts (7 days)</p>
            <p className="stat-value">{stats?.recentContacts || 0}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon stat-icon-warning">
            <TrendingUp size={24} />
          </div>
          <div className="stat-content">
            <p className="stat-label">Recent Agents (7 days)</p>
            <p className="stat-value">{stats?.recentAgents || 0}</p>
          </div>
        </div>

        <div className="stat-card" data-testid="stat-card-chats">
          <div className="stat-icon stat-icon-primary">
            <MessageSquare size={24} />
          </div>
          <div className="stat-content">
            <p className="stat-label">Chat Conversations</p>
            <p className="stat-value" data-testid="stat-total-chats">{stats?.totalChats || 0}</p>
            <p className="stat-sub">{stats?.convertedChats || 0} became leads · {stats?.recentChats || 0} this week</p>
          </div>
        </div>
      </div>

      <div className="admin-actions">
        <button 
          onClick={() => navigate('/admin/contacts')} 
          className="admin-action-btn admin-action-primary"
        >
          View Contact Submissions
        </button>
        <button 
          onClick={() => navigate('/admin/agents')} 
          className="admin-action-btn admin-action-secondary"
        >
          View Agent Applications
        </button>
        <button 
          onClick={() => navigate('/admin/chats')} 
          className="admin-action-btn admin-action-secondary"
          data-testid="view-chats-btn"
        >
          View Chat Conversations
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
